import Box from '@mui/material/Box'
import { Grid, TextField, Typography, CircularProgress } from '@mui/material';
import * as React from 'react'
import {
  addcustomer,
  addreseller,
  addserviceprovider,
} from '../../../../api/post/postApi'
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 230,
    },
  },
}

// router dom
import { useSearchParams } from 'react-router-dom'

// jwt
import jwt_decode from 'jwt-decode'
import { decodeToken, normalizeApiResponse, requiredLabel } from '../../../../helpers/HelperFunctions'
import { useCommonRedux } from '../../../../store/middlewares/CommonRedux';
import { setCustomerTrigger, setResellerTrigger, setServiceProviderTrigger } from '../../../../store/slice/homeSlice';
import { useToastContext } from '../../../../App';
import { StyledSmallTextField } from '../../../styles/styled-components/StyledFormFields';
import validator from 'validator';
import { Button } from './styled';

export default function NewDomain({
  toggleDrawer,
  config,
  currentRole,
  parentid,
  updateAddedCompany,
}) {
  const { dispatch } = useCommonRedux();
  const { toast } = useToastContext();
  const token = localStorage.getItem('sd_cp.jwt:tkn');
  const [searchparams] = useSearchParams();

  const [companyName, setcompanyname] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [emailHelperText, setEmailHelperText] = React.useState('');
  const [domainname, setdomainname] = React.useState('');

  const [companynameerror, setcompanyanmeerror] = React.useState('');
  const [companydomainerror, setcompanydomainerror] = React.useState('');

  const [customercompanyname, setcustomercompanyname] = React.useState('');
  const [customercompanyhelpertext, setcustomercompanyhelpertext] =
    React.useState('');

  const [resellercompanyname, setresellercompanyname] = React.useState('');
  const [resellerhelpertext, setresellerhelpertext] = React.useState('');
  const [loading, setloading] = React.useState(false)

  // ---------- Validation Helpers ----------
  const validateRequired = (value, setter, msg) => {
    if (!value) {
      setter(msg);
      return false;
    }
    setter('');
    return true;
  };

  const validateEmail = () => {
    if (!email) {
      setEmailHelperText('email is required');
      return false;
    }
    if (!validator.isEmail(email)) {
      setEmailHelperText('please enter valid email');
      return false;
    }
    setEmailHelperText('');
    return true;
  };

  // ---------- API Wrappers ----------
  const callApi = async (apiFn, payload, successMsg, triggerFn) => {
    setloading(true);
    try {
      const data = await apiFn(payload, config);
      if (data) {
        toast.showToast(successMsg);
        updateAddedCompany(currentRole, data.data.result);
        dispatch(triggerFn('triggered'));
      }
    } catch (error) {
      toast.showToast(normalizeApiResponse(error)?.message, 'error');
    } finally {
      setloading(false);
      toggleDrawer(false);
    }
  };

  const proceedServiceProvider = () => {
    if (!validateRequired(companyName, setcompanyanmeerror, 'company name is required') ||
      !validateRequired(domainname, setcompanydomainerror, 'domain name is required')) return;

    callApi(
      addserviceprovider,
      { companyName, subDomain: domainname },
      'Service Provider is Added Successfully',
      setServiceProviderTrigger
    );
  };


  const proceedCustomer = () => {
    if (!validateRequired(customercompanyname, setcustomercompanyhelpertext, 'company name is required') || !validateEmail()) return;
    let pid = searchparams.get('company_id') || decodeToken(token).company_id;
    callApi(
      addcustomer,
      { parentId: pid, companyName: customercompanyname, email },
      'Customer is Added Successfully',
      setCustomerTrigger
    );
  };

  const proceedReseller = () => {
    if (!validateRequired(resellercompanyname, setresellerhelpertext, 'company name is required') ||
      !validateEmail()) return;
    const pid = searchparams.get('company_id');
    if (pid) {
      callApi(
        addreseller,
        { parentId: pid, companyName: resellercompanyname, email },
        'Reseller is Added Successfully',
        setResellerTrigger
      );
    } else {
      const decoded = jwt_decode(token);
      callApi(
        addreseller,
        { parentId: decoded.company_id, companyName: resellercompanyname, email },
        'Reseller Added Successfully',
        setResellerTrigger
      );
    }
  };

  // ---------- Renderers ----------
  const renderFields = () => {
    switch (currentRole) {
      case 'serviceprovider':
        return (
          <>
            <Grid item md={12}>
              {requiredLabel('Company Name')}
              <StyledSmallTextField
                onChange={(e) => setcompanyname(e.target.value)}
                helperText={companynameerror}
                error={!!companynameerror}
                fullWidth
                data-cy="serviceprovidercompanyname"
              />
            </Grid>
            <Grid item md={12}>
              {requiredLabel('Domain')}
              <StyledSmallTextField
                onChange={(e) => setdomainname(e.target.value)}
                helperText={companydomainerror}
                error={!!companydomainerror}
                fullWidth
                data-cy="serviceproviderdomain"
              />
            </Grid>
          </>
        );
      case 'reseller':
        return (
          <>
            <Grid item md={12}>
              {requiredLabel('Company Name')}
              <StyledSmallTextField
                onChange={(e) => setresellercompanyname(e.target.value)}
                helperText={resellerhelpertext}
                error={!!resellerhelpertext}
                fullWidth
                data-cy="resellercompanyname"
              />
            </Grid>
            <Grid item md={12}>
              {requiredLabel('Email')}
              <StyledSmallTextField
                onChange={(e) => setEmail(e.target.value)}
                helperText={emailHelperText}
                error={!!emailHelperText}
                value={email}
                type="email"
                fullWidth
                data-cy="reselleremail"
              />
            </Grid>
          </>
        );
      case 'customer':
      case 'directcustomer':
        return (
          <>
            <Grid item md={12}>
              {requiredLabel('Company Name')}
              <StyledSmallTextField
                onChange={(e) => setcustomercompanyname(e.target.value)}
                helperText={customercompanyhelpertext}
                error={!!customercompanyhelpertext}
                fullWidth
                data-cy="customercompanyname"
              />
            </Grid>
            <Grid item md={12}>
              {requiredLabel('Email')}
              <StyledSmallTextField
                onChange={(e) => setEmail(e.target.value)}
                helperText={emailHelperText}
                error={!!emailHelperText}
                value={email}
                type="email"
                fullWidth
                data-cy='customeremail'
              />
            </Grid>
          </>
        );
      default:
        return null;
    }
  };

  const renderButton = () => {
    const buttonProps = {
      variant: 'contained',
      color: 'primary',
      disableElevation: true,
      size: 'large',
    };

    switch (currentRole) {
      case 'serviceprovider':
        return (
          <Button onClick={proceedServiceProvider} {...buttonProps}>
            Add New Service Provider &emsp; {loading && <CircularProgress sx={{ color: '#fff' }} size={20} />}
          </Button>
        );
      case 'reseller':
        return (
          <Button onClick={proceedReseller} {...buttonProps}>
            Add New Reseller &emsp; {loading && <CircularProgress sx={{ color: '#fff' }} size={20} />}
          </Button>
        );
      case 'customer':
      case 'directcustomer':
        return (
          <Button onClick={proceedCustomer} {...buttonProps}>
            Add New Customer &emsp; {loading && <CircularProgress sx={{ color: '#fff' }} size={20} />}
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Box role="presentation">
        <div
          style={{
            display: 'flex',
            width: '100%',

            justifyContent: 'space-between',
            padding: '5px 10px 0 20px',
          }}
        >
          <Grid container columnSpacing={4} rowSpacing={3}>
            {renderFields()}
          </Grid>
        </div>

        <Box
          style={{
            bottom: '10px',
            marginLeft: '20px',
            marginTop: '10px',
            background: '#fff',
            display: 'inline-flex',
            justifyContent: 'right',
          }}
        >
          {renderButton()}

        </Box>
      </Box>
    </>
  )
}
